import i18n from '../i18n';

export const projectPathWithFallBack = (projectPath?: string) => {
  return projectPath ? projectPath : i18n.t('No Project');
};

export const descriptionWithFallBack = (description?: string) => {
  return description ? description : i18n.t('No Description');
};
